import React, { useEffect, useState } from 'react';
import './NewCreateCampaign.css';
import './NewCreateCampaignAdditional.css';
import './NewCreateCampaignResponsive.css';
import 'primeicons/primeicons.css';
import NewMarketModal from "@/react_app/NewMarketModal/NewMarketModal";
import NewCampaignCoverModal from "@/react_app/NewCampaignCoverModal/NewCampaignCoverModal";
import NewCampaignOverview from "@/react_app/NewCampaignOverview/NewCampaignOverview";
import NewCampaignComplete from "@/react_app/NewCampaignComplete/NewCampaignComplete";
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Image } from 'primereact/image';
import { ProgressBar } from 'primereact/progressbar';
import { InputTextarea } from 'primereact/inputtextarea';
import { FileUpload } from 'primereact/fileupload';
import { paymentMethodsOptions } from "@/pages/campaigns/create/data.campaign";
import { CampaignPaymentMethod } from "@/data/types";
import noImage from "../img/no-image.png";
import {
  AppStoreIcon, BackIcon, BackIconWhite, FieldTip,
  GooglePlayIcon, LinkIcon, RedTriangle, RedX, SecretTip, WebPageIcon
} from "@/react_app/img/Icons";
import {
  PaymentMethodInfo, PaymentStep, getLinkFieldText, ENGAGEMENT_MINIMUM, MAX_URLS, MAX_TALKING_POINTS, progressPoints,
  categoryItemsIcons, cancelOptions, uploadOptions, chooseOptions, categoryItems, createTabItems, managementTabItems, TabStep
} from "@/react_app/NewCreateCampaign/NewCreateCampaignAdditional";
import { DEFAULT_CAMPAIGN_FEE } from "@/utils/globals/cpi-rate";
import { useCampaigns, usePage } from "@/modules";

function LinkFieldIcon(props) {
  return (
    <div>
      {props.index === 0 && <GooglePlayIcon />}
      {props.index === 1 && <AppStoreIcon />}
      {props.index >= 2 && <WebPageIcon />}
    </div>
  )
}

export default function(props) {
  const [progressCampaign, setProgressCampaign] = useState({});
  const [currentTab, setCurrentTab] = useState(1);
  const [progressBar, setProgressBar] = useState(0);
  const [reachedTab, setReachedTab] = useState(1);
  const [newlyCreatedCampaign, setNewlyCreatedCampaign] = useState('');
  const [openMarketModal, setOpenMarketModal] = useState(false);
  const [openCoverModal, setOpenCoverModal] = useState(false);
  const [isEndDateExact, setIsEndDateExact] = useState(false);
  const [disableLaunchButton, setDisableLaunchButton] = useState(false);
  const [disableDraftButton, setDisableDraftButton] = useState(false);
  const [campaign, setCampaign] = useState({
    campaignName: '',
    category: categoryItems[0],
    campaignEndDate: undefined,
    paymentMethod: CampaignPaymentMethod.CPC,
    marketTier: '',
    marketCountries: '',
    coverImage: noImage,
    campaignDescription: '',
    brandTrackingLink: '',
    attachments: [],
    gamekeys: '',
    otherUrls: ['', '', ''],
    talkingPoints: ['', ''],
    callToAction: '',
    campaignCPC: 0,
    campaignCPM: { amount: 0, payoutCap: 0 },
    campaignCPI: { ios: 0, android: 0 },
    campaignBudget: 0,
  });

  const { config } = usePage({ title: 'create campaign' });
  const page = useCampaigns(config?.value?.viewPerspective);

  useEffect(() => {
    if(reachedTab < currentTab) {
      setReachedTab(currentTab);

      if (reachedTab <= 3) {
        setProgressBar(reachedTab * 20);
      } else {
        setProgressBar(99);
      }
    }
  }, [currentTab]);

  useEffect(() => {
    if(props.campaign) {
      setCampaign(({
        campaignName: props.campaign.name,
        category: { type: props.campaign.targetMarket.type, name: props.campaign.targetMarket.title },
        campaignEndDate: props.campaign.dates.endDate,
        paymentMethod: props.campaign.paymentMethod,
        marketTier: props.campaign.desiredRegions[0]?.value,
        marketCountries: props.campaign.desiredRegions[0]?.name,
        coverImage: props.campaign.photo,
        campaignDescription: props.campaign.productName,
        brandTrackingLink: props.campaign.trackingLink,
        attachments: props.campaign.attachments,
        gamekeys: props.campaign.gamekeys,
        otherUrls: props.campaign.productUrls.map(item => item.value),
        talkingPoints: props.campaign.talkingPoints,
        callToAction: props.campaign.callToAction,
        campaignCPC: props.campaign.cpc.amount,
        campaignCPM: { amount: props.campaign.cpm?.amount, payoutCap: props.campaign?.payoutCap },
        campaignCPI: { ios: props.campaign.ios?.amount, android: props.campaign.android?.amount },
        campaignBudget: props.campaign.budget.amount,
      }));
    }
  }, [props.campaign]);

  useEffect(() => {
    setProgressCampaign({
      name: campaign.campaignName,
      budget: { amount: campaign.campaignBudget, amountLeft: campaign.campaignBudget, currency: 'USD' },
      dates: { startDate: new Date(), endDate: campaign.campaignEndDate },
      targetMarket: { type: campaign.category.type, title: campaign.category.name },
      desiredRegions: { name: campaign.marketCountries, value: campaign.marketTier },
      productName: campaign.campaignDescription,
      productUrls: campaign.otherUrls.map(function(link, index) {
          if (index === 0) {
              return { type: "Google", value: link };
          } else if (index === 1) {
              return { type: "Apple", value: link };
          }
          return { type: "Webpage", value: link };
      }),
      callToAction: campaign.callToAction,
      talkingPoints: campaign.talkingPoints,
      trackingLink: campaign.brandTrackingLink,
      attachments: campaign.attachments,
      gamekeys: campaign.gamekeys,
      cpi: { ios: { amount: campaign.campaignCPI.ios }, android: { amount: campaign.campaignCPI.android } },
      cpc: { amount: campaign.campaignCPC },
      cpm: { amount: campaign.campaignCPM.amount, payoutCap: campaign.campaignCPM.payoutCap },
      paymentMethod: campaign.paymentMethod,
      photo: campaign.coverImage,
      paymentInformation: {},
      appliedFee: DEFAULT_CAMPAIGN_FEE,
    });
  }, [campaign]);

  const createDraft = async (pushRouter) => {
    setDisableDraftButton(true);

    const createdDraft = await page.manager.create(progressCampaign);
    if (campaign.attachments?.length) {
      const formData = new FormData();
      for await (const file of campaign.attachments) {
        formData.set('files[]', file);
        await page.manager.attachments(createdDraft?.id, formData);
      }
    }
    if (pushRouter) {
      await props.pushDraft(createdDraft);
    }

    setDisableDraftButton(false);

    return createdDraft;
  };

  const launchCampaign = async () => {
    setDisableLaunchButton(true);

    if (!props.campaign) {
      await createDraft(false).then(async (createdCampaign) => {
        if (createdCampaign?.id) {
          setCurrentTab(currentTab + 1);
          setNewlyCreatedCampaign(createdCampaign);
        }
      });
    }

    setDisableLaunchButton(false);
  };

  const handleUrlChange = (e, index) => {
    setCampaign(prevState => ({
      ...prevState,
      otherUrls: prevState.otherUrls.map((item, i) => (i === index ? e.target.value : item)),
    }));
  };

  const handleRemoveUrl = (index) => {
    const newUrls = [...campaign.otherUrls];
    newUrls.splice(index, 1);
    setCampaign((prevState) => ({ ...prevState, otherUrls: newUrls }));
  };

  const handleTalkingPointChange = (e, index) => {
    setCampaign(prevState => ({
      ...prevState,
      talkingPoints: prevState.talkingPoints.map((item, i) => (i === index ? e.target.value : item)),
    }));
  };

  const handleRemoveTalkingPoint = (index) => {
    const newTalkingPoints = [...campaign.talkingPoints];
    newTalkingPoints.splice(index, 1);
    setCampaign((prevState) => ({ ...prevState, talkingPoints: newTalkingPoints }));
  };

  const checkMinimalBudget = (engagementAmount) => {
    return campaign.campaignBudget < (ENGAGEMENT_MINIMUM * engagementAmount) || campaign.campaignBudget === 0;
  }

  const checkDisabled = () => {
    if (disableLaunchButton) {
      return true;
    }
    else if (currentTab === 1 && (!campaign.campaignName || !campaign.marketCountries || campaign.coverImage === noImage)) {
      return true;
    }
    else if (currentTab === 4) {
      if (!campaign.campaignBudget) {
        return true;
      }

      if (campaign.paymentMethod === CampaignPaymentMethod.CPC) {
        return checkMinimalBudget(campaign.campaignCPC);
      } else if(campaign.paymentMethod === CampaignPaymentMethod.CPM) {
        return checkMinimalBudget(campaign.campaignCPM.amount);
      }
      return checkMinimalBudget(Math.max(campaign.campaignCPI.android, campaign.campaignCPI.ios));
    }
  }

  const checkDisabledDraft = () => {
    if (disableDraftButton) {
      return true;
    }
    else if (!campaign.campaignName || !campaign.marketCountries || campaign.coverImage === noImage) {
      return true;
    }

    return false;
  }

  const handleContinue = () => {
    setCurrentTab(currentTab + 1);
  }

  const onTemplateSelect = (e) => {
    const { files } = e;
    setCampaign(prevState => ({...prevState, attachments: files}));
  };

  const onTemplateRemove = (e) => {
    const { file } = e;
    setCampaign(prevState => ({...prevState, attachments: prevState.attachments.filter(attachment => attachment !== file)}));
  };

  const handleRouting = async (createdCampaign) => {
    await props.pushDraft(createdCampaign);
    await page.manager.pending(createdCampaign?.id);
  }

  const handleSaveEdit = () => {
    props.saveEdit(progressCampaign);
    window.location.reload(false);
  }

  return (
    <div className={'create-campaign'}>
      {!props.isCampaignManagement &&
        <div className={'return'} onClick={() => props.handleReturn()}>
          <BackIcon/>
          <span className={'returnText'}>Campaign Management</span>
        </div>
      }
      {currentTab < TabStep.Completed &&
        <div>
          <div className={'titleLayer'}>
            <p className={'title'}>{props.campaign ? 'Edit Campaign' : 'New Campaign'}</p>
            {props.campaign ?
              <div className={'campaignButtonGroup'}>
                <Button className={'secondaryButton'} onClick={() => props.cancelEdit()}>Cancel</Button>
                <Button className={'primaryButton'} disabled={checkDisabled()} onClick={() => handleSaveEdit()}>Update Campaign</Button>
              </div> :
              <Button className={'secondaryButtonSmall'} disabled={currentTab === 1} onClick={() => setCurrentTab(currentTab - 1)}><BackIconWhite/>To the previous step</Button>
            }
          </div>
          <div className={'tabLayer'}>
            {(!props.isCampaignManagement ? createTabItems : managementTabItems).map((item, index) =>
              <div key={index} className={(item.index === currentTab) ? 'tabLayerItemCurrent' : 'tabLayerItem'}
                   onClick={() => {if(index + 1 <= reachedTab) setCurrentTab(index + 1)}} style={{ width: props.isCampaignManagement ? '25%' : '20%' }}>
                <div className={(item.index === currentTab) ? 'tabNumberSelected' : 'tabNumber'}>
                  0{item.index}
                </div>
                <span className={'tabName'}>{item.name}</span>
                {(item.index === currentTab) && <RedTriangle />}
              </div>)}
          </div>
        </div>
      }
      <div className={'mainLayer'}>
        {currentTab === TabStep.Start && <div className={'step'}>
          <div>
            <p className={'fieldLabel'}>Campaign Name <span className={'redStar'}>*</span></p>
            <InputText className={'inputField'} value={campaign.campaignName} onChange={(e) =>
              setCampaign(prevState => ({...prevState, campaignName: e.target.value}))} placeholder={'Give your campaign a name'}/>
            <div className={'secretTip'}>
              <SecretTip/>
              <div>
                <p className={'secretTipTitle'}>Secret Tip</p>
                <p className={'secretTipText'}>Make sure this title is accurate to your product and snappy enough to entice creators!</p>
              </div>
            </div>
          </div>
          <div>
            <p className={'fieldLabel'}>Campaign End Date <span className={'redStar'}>*</span></p>
            <div className={'endDateField'}>
              <Calendar className={'calendarField'} value={campaign.campaignEndDate} onChange={(e) => { setCampaign(prevState =>
                ({...prevState, campaignEndDate: e.value})); setIsEndDateExact(true) }} dateFormat="dd/mm/yy"/>
              <span className={'endDateLabel'}>Or</span>
              <div className={isEndDateExact ? 'endDateOtherOption' : 'endDateOtherOptionSelected'}
                   onClick={() => { setIsEndDateExact(false); setCampaign(prevState => ({...prevState, campaignEndDate: undefined}))}}>
                <i className="pi pi-check" style={{ color: '#FFF', fontSize: '20px', marginRight: '10px' }}/>
                Until Budget is Complete
              </div>
            </div>
          </div>
          <div>
            <p className={'fieldLabel'}>Category <span className={'redStar'}>*</span></p>
            <div className={'categoryWrapper'}>
              {categoryItems.map((item, index) =>
                <div key={index} className={campaign.category.type === item.type ? 'categoryItemSelected' : 'categoryItem'}
                     onClick={() => setCampaign(prevState => ({...prevState, category: item}))}>
                  {categoryItemsIcons[index]}
                  <p className={'categoryText'}>{item.name}</p>
                </div>)}
            </div>
          </div>
          <div>
            <p className={'fieldLabel'}>Payment Method <span className={'redStar'}>*</span></p>
            <Dropdown className={'dropdownField'} value={campaign.paymentMethod} onChange={(e) => setCampaign(prevState => ({...prevState, paymentMethod: e.value}))}
                      options={paymentMethodsOptions} optionLabel="title" placeholder="Select payment method"/>
            <PaymentMethodInfo class={'paymentMethodText'} paymentMethod={campaign.paymentMethod}/>
          </div>
          <div>
            <p className={'fieldLabel'}>Market <span className={'redStar'}>*</span></p>
            <div className={'marketField'} onClick={() => setOpenMarketModal(true)}>
              <div>
                <p className={'marketFieldBold'}>{campaign.marketCountries ? campaign.marketTier : 'Select your preferred category'}</p>
                <p className={'marketFieldNormal'}>{campaign.marketCountries ? campaign.marketCountries : 'Make a selection on the type and coverage of the market'}</p>
              </div>
              <i className={'pi pi-plus'} style={{ color: '#FFF', fontSize: '24px', margin: '0 8px' }}/>
            </div>
          </div>
        </div>}
        {currentTab === TabStep.Details && <div className={'step'}>
          <div>
            <p className={'fieldLabel'}>Campaign Description</p>
            <InputTextarea autoResize value={campaign.campaignDescription} onChange={(e) => setCampaign(prevState => ({...prevState, campaignDescription: e.target.value}))}
                           rows={5} className={'textArea'} placeholder={'Tell creators about your campaign'}/>
          </div>
          <div>
            <p className={'fieldLabel'}>Campaign URLs</p>
            <div className={'urlsWrapper'}>
              <div>
                <div className={'urlLabel'}>Brand Tracking Link Input <FieldTip title={'Add the important link that will be' +
                  'used to track your conversions. For CPI this will be an Adjust or Appsflyer link. For CPC or CPM ' +
                  'this will be a general website link'}/>
                </div>
                <span className="p-input-icon-left">
                  <LinkIcon />
                  <InputText value={campaign.brandTrackingLink} onChange={(e) => setCampaign(prevState => ({...prevState, brandTrackingLink: e.target.value}))}
                       placeholder='Enter your link for tracking generation' className={'urlInput'}/>
                </span>
              </div>
              <div>
                <p className={'urlLabel'}>Gamekeys (if applicable)</p>
                <span className="p-input-icon-left">
                  <LinkIcon />
                  <InputText placeholder={`Enter your link to gamekey folder`} className={'urlInput gamekeys'} value={campaign.gamekeys} onChange={(e) => setCampaign(prevState => ({...prevState, gamekeys: e.target.value}))}/>
                </span>
                <div className={'otherUrlsWrapper'}>
                  {campaign.otherUrls?.map((item, index) =>
                    <div key={index} className={'linkWrapper'}>
                      <span className="p-input-icon-left">
                        <LinkFieldIcon index={index}/>
                        <InputText placeholder={`Enter your product ${getLinkFieldText(index)} URL`}
                                   className={'urlInput'} value={item} onChange={(e) => handleUrlChange(e, index)}/>
                      </span>
                      {index > 2 && <RedX onClick={() => handleRemoveUrl(index)}/>}
                    </div>)}
                  {campaign.otherUrls.length <= MAX_URLS && <p className={'addField'} onClick={() => setCampaign((prevState) => ({...prevState, otherUrls: [...prevState.otherUrls, '']}))}>+ Add another URL</p>}
                </div>
              </div>
            </div>
          </div>
        </div>}
        {currentTab === TabStep.Instructions && <div className={'step'}>
          <div>
            <p className={'talkingPointsTitle'}>Talking Points</p>
            <div className={'talkingPointsWrapper'}>
              {campaign.talkingPoints?.map((item, index) =>
                <div key={index}>
                  <p className={'talkingPointLabel'}>Talking point {index + 1}</p>
                  <InputText placeholder='Enter your desired talking point' className={'talkingPointField'} value={item}
                             onChange={(e) => handleTalkingPointChange(e, index)}/>
                  {index > 1 && <RedX onClick={() => handleRemoveTalkingPoint(index)}/>}
                </div>)}
              {campaign.talkingPoints.length <= MAX_TALKING_POINTS && <p className={'addField'} onClick={() => setCampaign((prevState) => ({...prevState, talkingPoints: [...prevState.talkingPoints, '']}))}>+ Add another Talking Point</p>}
            </div>
          </div>
          <div>
            <p className={'talkingPointsTitle'}>Call to action</p>
            <InputTextarea value={campaign.callToAction} onChange={(e) => setCampaign(prevState => ({...prevState, callToAction: e.target.value}))}
                           autoResize rows={5} className={'textArea'} placeholder={'Enter your call to action'}/>
          </div>
          <div>
            <p className={'talkingPointsTitle'}>Attachments</p>
            <FileUpload className={'fileUpload'} multiple emptyTemplate={<p className={'uploadText'}>Drag and drop files to here to upload.</p>} onRemove={onTemplateRemove}
                        chooseOptions={chooseOptions} uploadOptions={uploadOptions} cancelOptions={cancelOptions} onSelect={onTemplateSelect} chooseLabel="Upload"/>
          </div>
        </div>}
        {currentTab === TabStep.Budget && <div className={'step'}>
          <div>
            <p className={'fieldLabel'}>Payment Method</p>
            <PaymentMethodInfo class={'paymentMethodTextWhite'} paymentMethod={campaign.paymentMethod}/>
          </div>
          <PaymentStep campaign={campaign} setCampaign={setCampaign}/>
        </div>}
        {currentTab === TabStep.Overview && !props.isCampaignManagement &&
          <NewCampaignOverview launchCampaign={launchCampaign} saveDraft={createDraft} disableLaunchButton={disableLaunchButton} campaign={campaign} setCurrentTab={setCurrentTab}/>
        }
        {currentTab === TabStep.Completed && !props.isCampaignManagement &&
          <NewCampaignComplete campaign={newlyCreatedCampaign} handleRouting={() => handleRouting(newlyCreatedCampaign)}/>
        }
        {currentTab < TabStep.Overview &&
          <div className={'rightSide'}>
            <div className={'campaignProgress'}>
              {currentTab === 1 && <Button className={'editCoverImageButton'} onClick={() => setOpenCoverModal(true)}>Edit Cover Image</Button>}
              <div className={'campaignCoverImageWrapper'}>
                <Image src={campaign.coverImage} alt={'campaign cover image'} className={'campaignCoverImage'}/>
              </div>
              <p className={'campaignName'}>{campaign.campaignName ? campaign.campaignName : 'Campaign name'}</p>
              {!props.campaign && <p className={'progressBarText'}>{progressBar}% completed</p>}
              {!props.campaign && <ProgressBar value={progressBar}/>}
              <div className={'progressPointsWrapper'}>
                {progressPoints.map((point, index) =>
                  <div key={index} className={'progressPoint'}>
                    <div className={index < reachedTab ? 'progressPointRed' : 'progressPointWhite'}/>
                    <span className={'progressPointText'}>{point}</span>
                  </div>)}
              </div>
            </div>
            {props.campaign ?
              <div className={'campaignButtonGroup'}>
                <Button className={'secondaryButton'} disabled={currentTab === 1} onClick={() => setCurrentTab(currentTab - 1)}>Go Back</Button>
                <Button className={'primaryButton'} disabled={checkDisabled()} onClick={() => handleContinue()}>Continue</Button>
              </div> :
              <div className={'campaignButtonGroup'}>
                <Button className={'secondaryButton'} disabled={checkDisabledDraft()} onClick={() => createDraft(true)}>Save Draft</Button>
                <Button className={'primaryButton'} disabled={checkDisabled()} onClick={() => handleContinue()}>Continue</Button>
              </div>
            }
            {checkDisabledDraft() &&
              <p className={'draftDisabledText'}>Fill in the following fields: Campaign name, Market, Cover Image.</p>
            }
          </div>
        }
      </div>
      <NewMarketModal visible={openMarketModal} close={() => setOpenMarketModal(false)} marketTier={campaign.marketTier}
                      setMarketTier={(tier) => setCampaign(prevState => ({...prevState, marketTier: tier}))} setMarketCountries={(countries) => setCampaign(prevState => ({...prevState, marketCountries: countries}))}/>
      <NewCampaignCoverModal visible={openCoverModal} close={() => setOpenCoverModal(false)}
                             coverImage={campaign.coverImage} setCoverImage={(image) => setCampaign(prevState => ({...prevState, coverImage: image}))}/>
    </div>
  )
}
